import {expenseConstants} from '../constants';

const expenseState = {
  addExpenseModalProps: {
    open: false,
  },
  expense: {},
};

const expenseReducer = (state = expenseState, action) => {
  const {type, data} = action;
  switch (type) {
    case expenseConstants.CLOSE_ADD_EXPENSE_MODAL:
      return {
        ...state,
        addExpenseModalProps: { ...state.agentChatProps, open: false }
      }
    case expenseConstants.OPEN_ADD_EXPENSE_MODAL:
      return {
        ...state,
        addExpenseModalProps: { open: true, ...data }
      }
    case expenseConstants.GET_EXPENSE:
      return {
        ...state,
        expense: data
      }
    default:
      return state;
  }
};

export default expenseReducer;
